import {
  ALL_SUPPORTED_CATEGORY_TYPES_V2,
  ALL_TILE_ITEM_TYPES,
  CUSTOMIZED_TILE_ITEM_TYPES,
  TILE_LAYOUT_TYPE,
} from 'src/consumer/constants'
import { getStringFromHTMLString } from 'src/mentor/helpers/utilityFunctions'
import { getArticleLayoutLogic } from './components/layoutCards/article-layout-logic'
import { getSpreadBoardTileLogic } from './components/layoutCards/spread-board-logic'
import { getSquareMidLogic } from './components/layoutCards/square-mid-logic'
import { DefaultTileHeadingLogic, SquareMid } from './tile-classes'

let tileObjectManipulator = {
  [ALL_SUPPORTED_CATEGORY_TYPES_V2.activePlans]: setActivePlanCategoryTypeLogic,
}

let setTileHeadingBasedOnItemType = {
  [ALL_SUPPORTED_CATEGORY_TYPES_V2.activePlans]: setHeadingActivePlanCategoryTypeLogic,
}

let getTileCarouselLogicBasedOnLayoutType = {
  [TILE_LAYOUT_TYPE.spreadBoard]: getSpreadBoardTileLogic,
  [TILE_LAYOUT_TYPE.squareMid]: getSquareMidLogic,
  [TILE_LAYOUT_TYPE.articleLayout]: getArticleLayoutLogic,
}

export function getTileCarouselLogic(tileData, contextData) {
  const itemType = tileData?.itemType
  const carouselLogicMaker =
    getTileCarouselLogicBasedOnLayoutType?.[tileData?.layout] || getSpreadBoardTileLogic

  let tileCarouselLogic = {
    headingLogicAndData: getHeadingLogicAndDataForItemType(itemType, tileData, contextData),
    carouselLogicAndData: carouselLogicMaker(itemType, tileData, contextData),
  }

  console.log({ tileCarouselLogic })
  return tileCarouselLogic
}

export function getHeadingLogicAndDataForItemType(itemType, tileData, { setSelectedCategory }) {
  let headingLogic = new DefaultTileHeadingLogic(tileData)
  headingLogic.setTileData(tileData)
  headingLogic.setTileItemType(
    CUSTOMIZED_TILE_ITEM_TYPES?.[tileData?.itemType] || tileData?.itemType,
  )
  headingLogic.setCurrentCategoryType(tileData?.categoryType)
  switch (itemType) {
    case ALL_TILE_ITEM_TYPES.activityPlan:
      setHeadingLogicForActivityPlanTile(headingLogic, { setSelectedCategory })
      break
    case ALL_TILE_ITEM_TYPES.userMeditation:
      setHeadingLogicForUserMeditationTile(headingLogic, { setSelectedCategory })
      break
    default: {
      break
    }
  }
  return headingLogic
}

export function getCarouselLogicAndDataForItemType(itemType, tileData, { navigate }) {
  let tileItemLogic = new SquareMid()
  console.log({ tileItemLogicInit: tileItemLogic })

  tileItemLogic.setTileData(tileData)
  tileItemLogic.setTileItemType(
    CUSTOMIZED_TILE_ITEM_TYPES?.[tileData?.itemType] || tileData?.itemType,
  )
  tileItemLogic.setCurrentCategoryType(tileData?.categoryType)

  switch (itemType) {
    case ALL_TILE_ITEM_TYPES.activityPlan:
      setActivityPlanTileItemLogic(tileItemLogic, { navigate })
      break
    case ALL_TILE_ITEM_TYPES.article:
      setArticleTileItemLogic(tileItemLogic, { navigate })
      break
    default: {
      break
    }
  }

  return tileItemLogic
}

//////////////////////////LOGIC FOR DIFFERENT TILE ITEM TYPES//////////////////////////

////////////////ACTIVITY PLANS/////////////////////////

function setHeadingActivePlanCategoryTypeLogic(headingItemLogic, { setSelectedCategory }) {
  const currentTileData = headingItemLogic.tileData
  if (currentTileData?.layout === TILE_LAYOUT_TYPE.spreadBoard) {
    headingItemLogic.setGetTitle((item) => item?.[headingItemLogic.currentItemType]?.title)
  }
}

function setActivePlanCategoryTypeLogic(tileItemLogic, { navigate }) {
  const currentItemType = tileItemLogic.currentItemType
  const currentTileData = tileItemLogic.tileData

  const onClickLogic = (item) =>
    navigate(`/my-activity/${item?.[currentItemType]?.slug}`, {
      state: { planId: item?.[currentItemType]?.id, slug: item?.[currentItemType]?.slug },
    })

  tileItemLogic.setSecondaryItemsFunction((item) => item?.[currentItemType]?.plannedActivities)

  tileItemLogic.setSecondaryTextFunction((item) => item?.[currentItemType]?.description)

  currentTileData?.layout === TILE_LAYOUT_TYPE.squareMid &&
    tileItemLogic.setSecondaryTextFunction((item) => 'Active Plan')

  tileItemLogic.setActionButtonLogicFunction((item) => {
    return {
      text: 'Continue',
      onClick: onClickLogic,
    }
  })

  return tileItemLogic
}

function setHeadingLogicForActivityPlanTile(headingLogic, { setSelectedCategory }) {
  headingLogic.setOnClick(() => {
    setSelectedCategory(true)
  })
  if (setTileHeadingBasedOnItemType[headingLogic?.currentCategoryType]) {
    setTileHeadingBasedOnItemType?.[headingLogic?.currentCategoryType](headingLogic, {
      setSelectedCategory,
    })
  }
}

function setActivityPlanTileItemLogic(tileItemLogic, { navigate }) {
  let defaultTileItemLogicWithTileData = tileItemLogic
  const currentItemType = defaultTileItemLogicWithTileData.currentItemType

  let getSecondaryItems = null
  let getSecondaryText = (item) => 'Activity Plan'

  let onClickLogic = (item) => {
    const currentItem = item?.[currentItemType]
    navigate(!!currentItem?.slug ? `/plan/${currentItem?.slug}` : `/plan/id/${currentItem?.id}`)
  }

  defaultTileItemLogicWithTileData.setTitleField((item) => {
    return item?.[currentItemType]?.title
  })
  defaultTileItemLogicWithTileData.setMainImage((item) => item?.[currentItemType]?.coverIcon)
  defaultTileItemLogicWithTileData.setSecondaryCardImage((item) => item?.coverIcon)
  defaultTileItemLogicWithTileData.setSecondaryTextFunction(getSecondaryText)
  defaultTileItemLogicWithTileData.setActionButtonLogic((item) => ({
    text: 'Start',
    onClick: onClickLogic,
  }))
  defaultTileItemLogicWithTileData.setSecondaryItemsFunction(
    (item) => item?.[currentItemType]?.plannedActivities,
  )
  defaultTileItemLogicWithTileData.setSecondaryItemImage((item) => item?.coverIcon)
  defaultTileItemLogicWithTileData.setSecondaryItemTitle(
    (item) => item?.plannedActivity?.activityTitle,
  )
  defaultTileItemLogicWithTileData.setSecondaryItemTitle(
    (item) => item?.plannedActivity?.customCategoryTitle,
  )

  if (tileObjectManipulator[defaultTileItemLogicWithTileData?.currentCategoryType]) {
    tileObjectManipulator?.[defaultTileItemLogicWithTileData?.currentCategoryType](
      defaultTileItemLogicWithTileData,
      { navigate },
    )
  }
}

//////////////////////////ARTICLES/////////////////////////////////

function setArticleTileItemLogic(tileItemLogic, { navigate }) {
  let defaultTileItemLogicWithTileData = tileItemLogic
  const currentItemType = tileItemLogic.currentItemType
  const currentTileData = tileItemLogic.tileData

  let getSecondaryItems = null
  let getSecondaryText = (item) => 'Articles'

  let onClickLogic = (item) => {
    const currentItem = item?.[currentItemType]
    navigate(
      !!currentItem?.slug ? `/article/${currentItem?.slug}` : `/article/id/${currentItem?.id}`,
    )
  }

  defaultTileItemLogicWithTileData.setTitleField((item) => {
    return item?.[currentItemType]?.title
  })
  defaultTileItemLogicWithTileData.setMainImage(
    (item) =>
      item?.[currentItemType]?.coverImage ||
      item?.[currentItemType]?.coverIcon ||
      item?.[currentItemType]?.blogBanner,
  )
  defaultTileItemLogicWithTileData.setSecondaryCardImage((item) => item?.coverIcon)
  defaultTileItemLogicWithTileData.setSecondaryTextFunction(getSecondaryText)
  defaultTileItemLogicWithTileData.setActionButtonLogic((item) => ({
    text: 'Read',
    onClick: onClickLogic,
  }))

  currentTileData?.layout === TILE_LAYOUT_TYPE.articleLayout &&
    defaultTileItemLogicWithTileData.setSecondaryTextFunction((item) =>
      getStringFromHTMLString(item?.[currentItemType]?.content),
    )

  if (tileObjectManipulator[defaultTileItemLogicWithTileData?.currentCategoryType]) {
    tileObjectManipulator?.[defaultTileItemLogicWithTileData?.currentCategoryType](
      defaultTileItemLogicWithTileData,
      { navigate },
    )
  }
}

//////////////////////////PRACTICE TIMERS/////////////////////////////////
function setHeadingLogicForUserMeditationTile(headingLogic, { setSelectedCategory }) {
  headingLogic.setOnClick(() => {
    setSelectedCategory(true)
  })
  // if (setTileHeadingBasedOnItemType[headingLogic?.currentCategoryType]) {
  //   setTileHeadingBasedOnItemType?.[headingLogic?.currentCategoryType](headingLogic, {
  //     setSelectedCategory,
  //   })
  // }
}

// Code that might be useful for the future:

// tileItemLogic.getSecondaryItemViewType((secondaryItem)=>)
// const tileItemLogic = Object.create(currentTileItemLogicObject)
// tileItemLogic.setSecondaryItemsFunction((item) => createActivityPlanWithEstimatedCompletionDates(item?.[currentItemType],item?.))
